// extracted by mini-css-extract-plugin
export default {"bottomTextTitle":"_1mpy6","subTitle":"_32IvU","bottomTextSection":"_728tk"};